import { config } from "../config/config";

function retrieveCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);

    if (parts.length === 3) {
        parts.pop();
    }
    if (parts.length === 2) {
        if (name === config.authentication.userInfoCookie) {
            const partpop = parts.pop();
            const decoded = decodeURIComponent(partpop)
            const parsedcookie = decoded.split(';');
            return parsedcookie.shift();
        } else {
        const cookie = parts.pop().split(';').shift();
        return cookie;
        }

    }
}

function setAuthCookie(value) {
    const expires = "";
    const domain = window.location.hostname;
    document.cookie = `${config.authentication.authenticationCookie}=${value}; domain=.${domain}; path=/; expires=${expires}`;
}

function deleteAuthCookie() {
    const domain = window.location.hostname;
    document.cookie = `${config.authentication.authenticationCookie}=; domain=.${domain}; path=/; expires=-1`;
}

export const cgpCookieHelper = {
    retrieveCookie: retrieveCookie,
    setAuthCookie: setAuthCookie,
    deleteAuthCookie: deleteAuthCookie
}
